import { Injectable } from "@angular/core";
import { StorageHandlerService } from "@mobi-office-ui";
import { GlobalService } from "./global.service";

export const appFactory = (config: AppService) => () => {
  return config.init();
};

@Injectable({
  providedIn: "root",
})
export class AppService {
  private readonly storageKey = "token";

  constructor(
    private storageHandlerService: StorageHandlerService,
    private globalService: GlobalService
  ) {}

  init() {
    window.addEventListener("storage", event => {
      if (event.key === this.storageKey) {
        // Session ID has changed. Take appropriate action (e.g., logout or notify)
        this.checkSession();
      }
    });
  }

  checkSession(): void {
    const sessionId = this.storageHandlerService.getItem("token");
    if (!sessionId) {
      this.globalService.onLogout();
    } else {
      setTimeout(() => {
        window.location.reload();
        // this.globalService.reloadPageHandler();
      }, 1000);
    }
  }
}
